// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../Config.bs.js";
import * as CreateCustomerRepo from "./CreateCustomerRepo.bs.js";
import * as DummyCreateCustomerRepo from "./DummyCreateCustomerRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyCreateCustomerRepo.CreateCustomerRepo;
  } else {
    return CreateCustomerRepo.CreateCustomerRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
